import { useCallback, useEffect, useState } from 'react';
import { useImageLazyLoading } from './ImageLazyLoadingProvider';
import { useIsLazyLoaded } from './useIsLazyLoaded';

export function useLazyImageProps(imageId, imageRef) {
  const lazyLoaded = useIsLazyLoaded(imageId);
  const { reportImageLoaded } = useImageLazyLoading();
  const [fullyLoaded, setFullyLoaded] = useState(false);

  const loadImage = useCallback(() => {
    setFullyLoaded(true);
    reportImageLoaded(imageId);
  }, [imageId, reportImageLoaded]);

  useEffect(() => {
    imageRef.current?.addEventListener('load', loadImage);
    imageRef.current?.addEventListener('error', loadImage);

    return () => {
      imageRef.current?.removeEventListener('load', loadImage);
      imageRef.current?.removeEventListener('error', loadImage);
    };
  }, [imageRef, loadImage]);

  return {
    lazyLoaded,
    lazyImageVisibility: fullyLoaded ? 'unset' : 'hidden'
  };
}
